import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import TextBubble from '../ui-components/TextBubble'
import BottomSheetContent from './BottomSheetContent'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const BODY_CLASS = "text-[#6a6e6e] text-sm font-normal font-['Matter'] leading-[21px]"

export const RRLearnMoreBottomSheet = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: 'Rolling_Returns_Performance_See_WHY',
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent onDismiss={onDismiss}>
      <TextBubble text="Rolling returns is a better metric to track a mutual fund's long term performance." />
      <div className={`${BODY_CLASS} pb-1 flex flex-col gap-4 pt-4`}>
        <HelpDialogPassage accessibleLabel='Rolling returns is an average of multiple returns given by the same fund across many time-frames. Since it is an average of many data points, the impact of market fluctuations get balanced out.'>
          <span className={BODY_CLASS}>
            Rolling returns is an average of multiple returns given by the same fund across many time-frames. Since it
            is an average of many data points, the impact of market fluctuations get balanced out.
          </span>
        </HelpDialogPassage>
        <HelpDialogPassage accessibleLabel="This reveals the fund's long-term return potential, helping set achievable expectations from the fund.">
          <span className={BODY_CLASS}>
            This reveals the fund's long-term return potential, helping set achievable expectations from the fund.
          </span>
        </HelpDialogPassage>
      </div>
    </BottomSheetContent>
  )
}
